import React, { Fragment } from "react";
import { TextModal, Paragraph } from "scuid-x";
import styled from "styled-components";

/**
 * Styled components
 */
const PromptText = styled(Paragraph)`
  padding: 0;

  @media (min-width: 600px) {
    min-width: 500px;
  }
`;

export interface PopupModalProps {
  prompt: string;
  title: string;
  onClick: () => void;
}

export interface PopupModalState {
  open: boolean;
}

export class PopupModal extends React.Component<PopupModalProps, PopupModalState> {
  constructor(props: PopupModalProps) {
    super(props);
    this.state = {
      open: true,
    };
  }

  private handleClick = () => {
    this.setState({ open: !this.state.open });
    this.props.onClick();
  };

  public render() {
    const { open } = this.state;

    return (
      <Fragment>
        <TextModal
            isOpen={open}
            onCancel={this.handleClick}
            onConfirm={this.handleClick}
            heading={this.props.title}
            bodyText={this.props.prompt}
            primaryBtnText="OK"
            secondaryBtnText="Cancel"
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/manual-upload/PopupModal.tsx